<build-section
  [disabled]="disabled"
  [contentOnly]="true"
  [title]="'cakeBuilder.productDepositSection.title' | translate">
  <div class="mt-3"
       [innerHTML]="'cakeBuilder.productDepositSection.willBeAddedToTheOrder' | translate: {
                      price: deposit.price | currencyFormat: currency }">
  </div>

  <div class="mt-3" *ngIf="deposit?.helpText">
    {{ deposit?.helpText }}
  </div>
</build-section>
